namespace advisorop.components.servicer {

    class WorkflowInstanceDiagramController {

        lovs: Array<domains.ILOV> = [];

        wfdiagram: DevExpress.ui.dxDiagramOptions;

        updatingWorkflowLadda: boolean = false;

        model: domains.IWorkflowInstance;

        workflowNodesArrayDataSource: DevExpress.data.ArrayStore;
        workflowEdgesArrayDataSource: DevExpress.data.ArrayStore;
        workflowNodesDataSource: DevExpress.data.DataSource;
        workflowEdgesDataSource: DevExpress.data.DataSource;

        showDiagram = true;
        showEditFields = false;
        selElementIsDirty = false;
        selItemType: string;
        selKey: string;
        selNode: domains.IWorkflowShape;
        selEdge: domains.IWorkflowConnector;
        workflowId: number;
        onSaveWorkflow: any;

        initialWorkflowNodes: domains.IWorkflowShape[];
        initialWorkflowEdges: domains.IWorkflowConnector[];

        nodeMap: Map<string, domains.IWorkflowShape>;
        edgeMap: Map<string, domains.IWorkflowConnector>;

        stepStatus_ACTIVE = domains.WorkflowStepStatus.ACTIVE;
        stepStatus_CLAIMED = domains.WorkflowStepStatus.CLAIMED;
        stepStatus_COMPLETED = domains.WorkflowStepStatus.COMPLETED;

        public theDiagram: DevExpress.ui.dxDiagram;

        static $inject = ["generalService", "identityService", "servicerService", "advisoryFirmApi", "workflowApi"];
        constructor(private generalService: services.GeneralService,
            private identityService: services.IdentityService,
            private servicerService: services.ServicerService,
            private advisoryFirmApi: services.AdvisoryFirmApi,
            private workflowApi: services.WorkflowApi) {

            this.selNode = new domains.IWorkflowShape();
            this.selEdge = new domains.IWorkflowConnector();

            this.nodeMap = new Map<string, domains.IWorkflowShape>();
            this.edgeMap = new Map<string, domains.IWorkflowConnector>();

            this.initNodemap();
            this.initEdgemap();

            this.wfdiagram = <DevExpress.ui.dxDiagramOptions>({
                width: "100%",
                height: "100%",
                nodes: {
                    dataSource: new DevExpress.data.DataSource({
                        key: "this",
                        store: new DevExpress.data.ArrayStore({
                            key: "id",
                            data: this.getWorkflowNodesArrayData(),
                        })
                    })
                },
                edges: {
                    dataSource: new DevExpress.data.DataSource({
                        key: "this",
                        store: new DevExpress.data.ArrayStore({
                            key: "id",
                            data: this.getWorkflowEdgesArrayData(),
                        })
                    }),
                    textExpr: "text",
                },
                focusStateEnabled: false,
                fullScreen: false,
                //rtlEnabled: false,
                simpleView: true,
                propertiesPanel: { visibility: "disabled" },
                contextMenu: { enabled: false },
                autoZoomMode: "fitWidth",
                pageColor: "#82CAFA",
                toolbox: { visibility: "disabled" },
                viewToolbar: { visible: false },
                readOnly: true,
                contextToolbox: { enabled: false },
                onInitialized: (e) => {
                    this.theDiagram = e.component;
                },
                onItemClick: (e: any) => {
                    console.log("item has been clicked :", e);

                    if (this.selElementIsDirty) {
                        if (window.confirm("Save previous changes?")) {
                            this.saveSelData();
                        }
                    }

                    const itemKey = e.item.key ?? e.item.dataItem.id;

                    // Sync our nodemap - add any new shapes
                    if (e.item.type !== "terminator") {
                        if (e.item.itemType === "shape") {
                            this.selItemType = "Shape";
                            this.bindNodeToForm(itemKey);
                            this.selElementIsDirty = false;
                            this.showEditFields = true;

                        } else if (e.item.itemType === "connector") {
                            this.selItemType = "Connector";
                            if (this.bindEdgeToForm(itemKey)) {
                                this.selElementIsDirty = false;
                                this.showEditFields = true;
                            } else {
                                this.showEditFields = false;
                            }

                            // old test code... ignore
                            //var dStore = thie.theDiagram.getNodeDataSource().store();
                            //let ind = this.theDiagram.getNodeDataSource().items().findIndex(node => node.id == e.item.key);
                            //var itms = this.theDiagram.getNodeDataSource().items();
                            //itms[ind].name = "BBBDJAEE";
                            //this.theDiagram.getNodeDataSource().reload();
                            //this.theDiagram.repaint();

                        } else {
                            this.showEditFields = false;
                        }
                    } else {
                        this.showEditFields = false;
                    }
                },
                //onRequestLayoutUpdate: (e: any) => {
                //    //console.log("IN UPDATE CALLBACK!!!!!", e);
                //    e.changes.forEach(change => {
                //        if (change.type === "insert" || change.type === "update") {
                //            if (change.data.hasOwnProperty('type')) {
                //                // shape
                //                //console.log("ADDING/UPDATING SHAPESHAPE");
                //                this.bindNodeToForm(change.key);
                //            } else if (change.data.hasOwnProperty('from')) {
                //                // connector
                //                //console.log("ADDING/UPDATING EDGE");
                //                this.bindEdgeToForm(change.key);
                //            }
                //        } else if (change.type === "remove") {
                //            if (this.nodeMap.has(change.key)) {
                //                //console.log("DELETING SHAPE");
                //                this.nodeMap.delete(change.key);
                //            } else if (this.edgeMap.has(change.key)) {
                //                //console.log("DELETING EDGE");
                //                this.edgeMap.delete(change.key);
                //            }
                //        }
                //    });
                //},
                onSelectionChanged: (e: any) => {
                    //console.log("IN ON SELECTION CHANGED!!!!!", e);
                },
                //onOptionChanged: (e: any) => {
                //    console.log("IN ON OPTION CHANGED!!!!!", e);
                //},
                //hoverStateEnabled: true,
                //onRequestEditOperation: (e: any) => {
                //    console.log("IN ON REQUEST EDIT OPERATION!!!!!", e);
                //},
                customShapes: [
                    {
                        baseType: "process",
                        type: "aoprocess",
                        toolboxTemplate: "toolboxTemplate"
                    },
                    {
                        baseType: "decision",
                        type: "aodecision",
                        toolboxTemplate: "toolboxTemplate"
                    },
                ],
                customShapeTemplate: "nodeShapeTemplate",
            });
        }

        initNodemap(): void {
            this.nodeMap.clear();
            // initialize the nodemap eith supplemntal fields - this is our internal data structure where we manage the supplemental node data
            this.model.diagram.shapes.forEach(n => {
                var node = new domains.IWorkflowShape();
                node.id = n.id;
                node.claimAllowedAllTimes = n.claimAllowedAllTimes;
                node.autoComplete = n.autoComplete;

                this.nodeMap.set(node.id, node);
            });
        }

        initEdgemap(): void {
            this.edgeMap.clear();
            // initialize the edgemap eith supplemntal fields - this is our internal data structure where we manage the supplemental edge data
            this.model.diagram.connectors.forEach(n => {
                var edge = new domains.IWorkflowConnector();
                edge.id = n.id;
                edge.positivityIndicator = n.positivityIndicator;

                this.edgeMap.set(edge.id, edge);
            });
        }

        infoToolTipHtml(item: any): string {
            //console.log("TOOLTIP HTML", item);

            var ret = "";

            const nodeData = this.theDiagram.getNodeDataSource().items();
            const ind = nodeData.findIndex(node => node.id === item.key);
            if (ind >= 0) {
                const text = (nodeData[ind].hasOwnProperty('text')) ? nodeData[ind].text : "";

                ret = "<p><h5>Properties:</h5></p>";
                ret += "<p style=text-align:\"left\"><strong>Name:</strong> " + text + "<br /><br />";

                if (this.nodeMap.has(item.key)) {
                    const itemm = this.nodeMap.get(item.key);
                    ret += "<strong>Description:</strong> " + itemm.description + "<br /><br />";
                    //ret += "<strong>Allow claim out of order:</strong> " + (itemm.claimAllowedAllTimes == true ? "Yes" : "No") + "<br /><br />";
                    //ret += "<strong>Auto-detect completion:</strong> " + (itemm.autoComplete == true ? "Yes" : "No") + "</p>";
                    ret += "<br /><button class=\"btn btn-info btn-sm\" ng-click=\"vm.claimSelected()\">Claim</button>";
                } else {
                    ret += "<strong>Description:</strong> undefined<br /><br />";
                    //ret += "<strong>Allow claim out of order:</strong> No<br /><br />";
                    //ret += "<strong>Auto-detect completion:</strong> No</p>";
                    ret += "<br /><button class=\"btn btn-info btn-sm\" ng-click=\"vm.claimSelected()\">Claim</button>";
                }
            }

            //console.log("RETURNING TOOLTIP HTML:", ret)
            return ret;
        }

        claimSelected(): void {
            //console.log("CLAIM SELECTED!!!");
        }

        bindNodeToForm(key: string) {
            //console.log("BINDING NODE TO FORM FOR KEY:", key);

            const nodeData = this.theDiagram.getNodeDataSource().items();
            //console.log("NODE ITMS:", nodeData);

            this.selKey = key;
            this.selNode.id = key;
            const ind = nodeData.findIndex(node => node.id === key);
            this.selNode.text = nodeData[ind].hasOwnProperty('text') ? nodeData[ind].text : "";

            //console.log("IND----:", ind);
            //console.log("SET NODE TEXT TO:", this.selNode.text);

            if (this.nodeMap.has(key)) {
                const node = this.nodeMap.get(key);
                this.selNode.description = node.description;
                this.selNode.claimAllowedAllTimes = node.claimAllowedAllTimes;
                this.selNode.autoComplete = node.autoComplete;
            } else {
                this.selNode.description = undefined;
                this.selNode.claimAllowedAllTimes = false;
                this.selNode.autoComplete = false;
            }
        }

        bindEdgeToForm(key: string): boolean {
            //console.log("BINDING EDGE TO FORM FOR KEY:", key);

            const edgeData = this.theDiagram.getEdgeDataSource().items();
            const nodeData = this.theDiagram.getNodeDataSource().items();
            //console.log("EDGE ITMS:", edgeData);

            const ind = edgeData.findIndex(edge => edge.id === key);
            //console.log("IND----:", ind);
            const fromNode = nodeData.findIndex(node => node.id === edgeData[ind].from);

            // For edges, we only bind to the form when the edge comes from a decision node.
            if (fromNode >= 0 && nodeData[fromNode].type === "aodecision") {
                this.selKey = key;
                this.selEdge.id = key;

                this.selEdge.text = edgeData[ind].hasOwnProperty('text') ? edgeData[ind].text : "";
                //console.log("SET EDGE TEXT TO:", this.selEdge.text);

                if (this.edgeMap.has(key)) {
                    const edge = this.edgeMap.get(key);
                    this.selEdge.description = edge.description;
                    this.selEdge.positivityIndicator = edge.positivityIndicator;
                } else {
                    this.selEdge.description = undefined;
                    this.selEdge.positivityIndicator = undefined;
                }
                return true;
            } else {
                return false;
            }
        }

        setElementDirty() {
            //console.log("Setting the selected element to dirty");
            this.selElementIsDirty = true;
        }

        resetSelDataInForm(): void {
            if (this.selItemType === "Shape") {
                this.bindNodeToForm(this.selKey);
                this.selElementIsDirty = false;
            }
            else if (this.selItemType === "Connector") {
                this.bindEdgeToForm(this.selKey);
                this.selElementIsDirty = false;
            }
        }

        cancelSelDataUpdate(): void {
            this.showEditFields = false;
            this.selElementIsDirty = false;
        }

        saveSelData(): void {
            if (this.selItemType === "Shape") {
                if (this.nodeMap.has(this.selKey)) {
                    this.nodeMap.delete(this.selKey);
                }
                this.nodeMap.set(this.selKey, angular.copy(this.selNode));
            }
            else if (this.selItemType === "Connector") {
                if (this.edgeMap.has(this.selKey)) {
                    this.edgeMap.delete(this.selKey);
                }
                this.edgeMap.set(this.selKey, angular.copy(this.selEdge));
            }
            this.selElementIsDirty = false;
        }

        getWorkflowNodesArrayData() {
            return this.model.diagram.shapes;
        }

        getWorkflowEdgesArrayData() {
            return this.model.diagram.connectors;
        }

        redrawCurrentWorkflow(): void {
            this.buildWorkflowModel();
            this.theDiagram.getNodeDataSource().reload();
            this.theDiagram.getEdgeDataSource().reload();
            //console.log("REDRAW WORKFLOW, CURRENT WORKFLOW IS:", this.model);
        }

        buildWorkflowModel(): void {
            this.model.diagram.shapes = [];
            const nodeData = this.theDiagram.getNodeDataSource().items();
            //console.log("THENODEDATA:", nodeData);
            nodeData.forEach(node => {
                var nodeToAdd = new domains.IWorkflowShape();
                nodeToAdd.aoId = node.hasOwnProperty('aoId') ? node.aoId : 0;
                nodeToAdd.id = node.id;
                nodeToAdd.type = node.type;
                //nodeToAdd.text = JSON.stringify(node.text);
                nodeToAdd.text = node.text;
                if (this.nodeMap.has(node.id)) {
                    const nodeSupp = this.nodeMap.get(node.id);
                    nodeToAdd.claimAllowedAllTimes = nodeSupp.claimAllowedAllTimes;
                    nodeToAdd.autoComplete = nodeSupp.autoComplete;
                } else {
                    nodeToAdd.claimAllowedAllTimes = false;
                    nodeToAdd.autoComplete = false;
                }
                this.model.diagram.shapes.push(nodeToAdd);
            });

            this.model.diagram.connectors = [];
            const edgeData = this.theDiagram.getEdgeDataSource().items();
            //console.log("THEEDGEDATA:", edgeData);
            edgeData.forEach(edge => {
                var edgeToAdd = new domains.IWorkflowConnector();
                edgeToAdd.aoId = edge.hasOwnProperty('aoId') ? edge.aoId : 0;
                edgeToAdd.id = edge.id;
                edgeToAdd.from = edge.from;
                edgeToAdd.to = edge.to;
                edgeToAdd.text = JSON.stringify(edge.text);
                //try {
                //    const tmp = JSON.parse(edge.text);
                //    edgeToAdd.text = JSON.stringify(edge.text);
                //} catch (e) {
                //    edgeToAdd.text = edge.text;
                //}
                if (this.edgeMap.has(edge.id)) {
                    const edgeSupp = this.edgeMap.get(edge.id);
                    edgeToAdd.positivityIndicator = edgeSupp.positivityIndicator
                } else {
                    edgeToAdd.positivityIndicator = domains.PositivityIndicator.NEUTRAL;
                }
                //console.log("EDGE TO ADD IS:", edgeToAdd);
                this.model.diagram.connectors.push(edgeToAdd);
            });
        };

        claimTask(task: domains.IWorkflowShape): void {
            //console.log("CLAIMING TASK", task);
            task.step.workflowStepStatus = domains.WorkflowStepStatus.CLAIMED;
        }

        logout(): void {
            this.identityService.logout();
        }

        $onInit(): void {
        }
    }

    class WorkflowInstanceDiagram implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                model: "<",
                workflowInstanceId: "<"
            };
            this.controller = WorkflowInstanceDiagramController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/workflow-instance-diagram.html';
        }
    }
    angular.module(Constants.APP).component("workflowInstanceDiagram", new WorkflowInstanceDiagram());
}